// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d8e848ac","172":"d96a73a3","203":"4b4e8228","372":"6ee8b056","407":"94d8c02f","464":"25b8939a","483":"f758176b"}[chunkId] + ".chunk.js";
};